import { Loading } from '@/pages/reports/non-ats-reports/shared/loading';
import {
  Box,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  ModalCloseButton,
} from '@chakra-ui/react';
import SearchIcon from '@/icons/Search';
import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash-es';
import { CandidatesTable } from '@/pages/reports/non-ats-reports/shared/candidates-popup';

export const CandidatesPopup = ({
  isOpen,
  onClose,
  isLoading,
  data,
  title,
  description,
}) => {
  const [search, setSearch] = useState('');

  const filteredData = useMemo(() => {
    return data.filter((datum) => {
      if (search.length) {
        return `${datum?.first_name} ${datum?.last_name}`
          .toLowerCase()
          .includes(search.toLowerCase());
      }
      return true;
    });
  }, [data, search]);

  useEffect(() => {
    if (isOpen) {
      setSearch('');
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered p="0">
      <ModalOverlay />
      <ModalContent height="580px">
        <ModalCloseButton />
        <ModalBody padding="24px">
          <Text fontSize="24px" fontWeight="semiBold" marginRight="24px">
            {title}
          </Text>
          <Text color="rgba(22, 22, 22, 0.50)" mt="12px">
            {description}
          </Text>
          <Box mt="12px">
            <InputGroup>
              <InputLeftElement
                pointerEvents="none"
                children={<SearchIcon />}
              />
              <Input
                placeholder="Search"
                onChange={debounce(
                  (event) => setSearch(event.target.value),
                  300
                )}
              />
            </InputGroup>
          </Box>
          <Box mt="12px">
            {isLoading ? (
              <Box height="345px">
                <Loading />
              </Box>
            ) : (
              <CandidatesTable data={filteredData} />
            )}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
